import api from "./client";

export async function listDowntimeReasons(includeInactive = false) {
  const res = await api.get("/downtime-reasons", {
    params: includeInactive ? { include_inactive: 1 } : undefined,
  });
  return res.data.data;
}

export async function createDowntimeReason(payload) {
  const res = await api.post("/downtime-reasons", payload);
  return res.data.data;
}

export async function updateDowntimeReason(id, payload) {
  const res = await api.put(`/downtime-reasons/${id}`, payload);
  return res.data.data;
}

export async function deleteDowntimeReason(id) {
  const res = await api.delete(`/downtime-reasons/${id}`);
  return res.data.data;
}
